import React from "react";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import Datenschutzerklaerung from "../../components/datenschutzerklaerung/datenschutzerklaerung.component";

const DatenschutzerklaerungPage = () => (
  <div>
    <PageHeaderComponent title="Erklärung zum Datenschutz" />
    <Datenschutzerklaerung />
  </div>
);

export default DatenschutzerklaerungPage;
